import { CompanyNanoID } from '../companies/companiesTypes';

export class CompanySmartContractSettingCache {
  static companyCompanySmartContractSettings(companyNanoId: CompanyNanoID) {
    return `company-${companyNanoId}-smart-contract-settings`;
  }
}
